import type { FC } from 'react';

import { DotsLoaderStyled } from './DotsLoader.styled';

interface Props {
  size?: number;
  offsetX?: string; // left shift in px
  offsetY?: string; // vertical shift in px
  color?: string; // vertical shift in px
}

const DotsLoader: FC<Props> = ({ size = 10, offsetX = '', offsetY = '', color = '' }) => (
  <DotsLoaderStyled size={size} offsetX={offsetX} offsetY={offsetY} color={color} />
);

export default DotsLoader;
